import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CONFIGURACION} from '../../config';
import {AuthHttp} from 'angular2-jwt/angular2-jwt';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {take} from 'rxjs/operators';

@Injectable({
   providedIn: 'root'
})
export class BackendApiService {
   constructor(
     public http: HttpClient,
     public authHttp: AuthHttp
   ) {
   }
   
   get(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL}/${api}`, {params: params});
   }
   
   getServerTs(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`, {params: params, headers: this.getHeaders()});
   }
   
   getServerTsv2(api: string, params?: any): any | Observable<any> | Observable<any[]> {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`, {params: params, headers: this.getHeaders()});
   }
   
   getServerTsGeneric(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`);
   }
   
   getAuth(api: string, params?: any): Observable<any> {
      return this.authHttp.get(`${CONFIGURACION.SERVER_URL}/${api}`, {params: params}).map(response => {
         return response.json();
      });
   }
   
   delete(api: string, params?: any) {
      return this.http.delete(`${CONFIGURACION.SERVER_URL}/${api}`, {params: params});
   }
   
   post(api: String, data: any) {
      return this.http.post(`${CONFIGURACION.SERVER_URL}/${api}`, data);
   }
   
   getDatosStockSap(tipo) {
      return this.http.get(`${CONFIGURACION.SERVER_URL}/api/reportsIntra/stock?codigo=` + tipo);
   }
   
   getRegistrosSanitarios() {
      return this.http.get(`${CONFIGURACION.SERVER_URL}/api/reportsIntra/registrosSanitarios`);
   }
   
   getHeaders() {
      let header = new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'});
      
      return header;
   }
   
   /**
    * Ejecutar peticiones http asíncronas
    * @param api
    * @param params
    */
   getAsync(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`, {params: params, headers: this.getHeaders()}).toPromise();
   }
   
   getAsyncJs(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL}/${api}`, {params: params}).toPromise();
   }
   
   getAsyncGeneric(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`).toPromise();
   }
   
   getTs(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`, {params: params, headers: this.getHeaders()}).pipe(
        take(1)
      );
   }
   
   getTsGeneric(api: string, params?: any) {
      return this.http.get(`${CONFIGURACION.SERVER_URL_TS}/${api}`)
        .pipe(
          take(1)
        );
   }
   
   postTs(api: string, body: any, params?: any) {
      return this.http.post(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body, {params: params, headers: this.getHeaders()})
        .pipe(
          take(1)
        );
   }
   
   postTsv2(api: string, body: any, params?: any): any | Observable<any | any[]> {
      return this.http.post(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body, {params: params, headers: this.getHeaders()})
        .pipe(
          take(1)
        );
   }
   
   postTsAsync(api: string, body: any, params?: any) {
      return this.http.post(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body, {params: params, headers: this.getHeaders()})
        .pipe(
          take(1)
        ).toPromise();
   }
   
   postSGeneric(api: string, body: any, params?: any) {
      return this.http.post(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body)
        .pipe(
          take(1)
        );
   }
   
   putTs(api: string, body: any, params?: any) {
      return this.http.put(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body, {params: params, headers: this.getHeaders()})
        .pipe(
          take(1)
        );
   }
   
   putTsGeneric(api: string, body: any, params?: any) {
      return this.http.put(`${CONFIGURACION.SERVER_URL_TS}/${api}`, body).pipe(
        take(1)
      );
   }
   
   deleteTs(api: string, params?: any) {
      return this.http.delete(`${CONFIGURACION.SERVER_URL_TS}/${api}`, {params: params, headers: this.getHeaders()})
        .pipe(
          take(1)
        );
   }
   
   deleteTsGeneric(api: string, params?: any) {
      return this.http.delete(`${CONFIGURACION.SERVER_URL_TS}/${api}`)
        .pipe(
          take(1)
        );
   }
}
